import styled from 'styled-components';

const CategoryNavbarStyle = styled.div`
	--catSize: 33.333%;
	--catPadding: var(--sp5x);
	--catInnerPadding: var(--sp2x);
	--catInnerPaddingTop: var(--sp5x);
	--iconSize: var(--sp8x);
	--iconMarginBottom: var(--sp2x);
	--destSlideWidth: 34.3%;
	--destSlideTitleMarginTop: var(--sp2x);

	::-webkit-scrollbar {
		display: none;
	}

	.cats-container {
		display: flex;
		flex-wrap: wrap;
		margin: 0 calc(var(--catPadding) / -2) var(--infoContPadding);

		.cat {
			width: var(--catSize);
			padding: 0 calc(var(--catPadding) / 2) var(--catPadding);
			flex: 0 1 auto;

			.cat-inner-cont {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				height: 100%;
				padding: var(--catInnerPaddingTop) var(--catInnerPadding) var(--catInnerPadding);
				transition: background var(--trTime);
				border-radius: var(--sp2x);
				overflow: hidden;
				transform: translateZ(0);
				cursor: pointer;

				.cat-image-cont {
					position: relative;

					.imageCont {
						--imagePaddingTop: var(--iconSize);

						width: var(--iconSize);
						margin-bottom: var(--iconMarginBottom);
					}

					.cat-image {
						opacity: 1;
						transition: all var(--trTime);
					}

					.cat-hover-image {
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						opacity: 0;
						transition: all var(--trTime);
					}
				}

				.cat-title {
					display: flex;
					align-items: center;
					text-align: center;
					flex: 1;
					min-height: 3.5em;
					transition: color var(--trTime);
					overflow: hidden;
				}

				@media (hover: hover) {
					&:hover {
						color: var(--primaryColor3);

						.cat-image-cont {
							.cat-image {
								opacity: 0;
							}

							.cat-hover-image {
								opacity: 1;
							}
						}
					}
				}
			}
		}
	}

	.top-dest-cont {
		.top-destination-slider-container {
			.top-destination-slider {
				margin-right: calc(-1 * var(--infoContPadding));
				margin-left: calc(-1 * var(--infoContPadding));

				.top-destination-slide {
					width: var(--destSlideWidth);
					margin-right: calc(var(--catPadding) / 2);
					margin-left: calc(var(--catPadding) / 2);
					cursor: pointer;

					&:last-child {
						margin-right: var(--infoContPadding);
					}

					&:first-child {
						margin-left: var(--infoContPadding);
					}

					.imageCont {
						--imagePaddingTop: 120.44%;

						border-radius: var(--sp2x);
						transform: translateZ(0);
						overflow: hidden;
					}

					.dest-slide-title {
						margin-top: var(--destSlideTitleMarginTop);
					}
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--catSize: 33.333%;
		--catPadding: var(--sp4x);
		--catInnerPadding: var(--sp2x);
		--catInnerPaddingTop: var(--sp4x);
		--iconSize: var(--sp6x);
		--iconMarginBottom: var(--sp2x);
		--destSlideWidth: 34.3%;
		--destSlideTitleMarginTop: var(--sp1-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--catSize: 33.333%;
		--catPadding: var(--sp3x);
		--catInnerPadding: var(--sp2x);
		--catInnerPaddingTop: var(--sp3x);
		--iconSize: var(--sp5x);
		--iconMarginBottom: var(--sp2x);
		--destSlideWidth: 34.3%;
		--destSlideTitleMarginTop: var(--sp1-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--catSize: 33.333%;
		--catPadding: var(--sp2x);
		--catInnerPadding: var(--sp2x);
		--catInnerPaddingTop: var(--sp3x);
		--iconSize: var(--sp5x);
		--iconMarginBottom: var(--sp1-5x);
		--destSlideWidth: 34.3%;
		--destSlideTitleMarginTop: var(--sp1-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--catSize: 33.333%;
		--catPadding: var(--sp2x);
		--catInnerPadding: var(--sp2x);
		--catInnerPaddingTop: var(--sp3x);
		--iconSize: var(--sp6x);
		--iconMarginBottom: var(--sp1-5x);
		--destSlideWidth: 34.3%;
		--destSlideTitleMarginTop: var(--sp1-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--catSize: 50%;
		--catPadding: var(--sp2x);
		--catInnerPadding: var(--sp2x);
		--catInnerPaddingTop: var(--sp3x);
		--iconSize: var(--sp6x);
		--iconMarginBottom: var(--sp1-5x);
		--destSlideWidth: 40%;
		--destSlideTitleMarginTop: var(--sp1-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--catSize: 33.333%;
		--catPadding: var(--sp2x);
		--catInnerPadding: var(--sp2x);
		--catInnerPaddingTop: var(--sp3x);
		--iconSize: var(--sp6x);
		--iconMarginBottom: var(--sp1-5x);
		--destSlideWidth: 40%;
		--destSlideTitleMarginTop: var(--sp1-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.MobileSize}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--catSize: 33.333%;
		--catPadding: var(--sp2x);
		--catInnerPadding: var(--sp2x);
		--catInnerPaddingTop: var(--sp3x);
		--iconSize: var(--sp6x);
		--iconMarginBottom: var(--sp1-5x);
		--destSlideWidth: 40%;
		--destSlideTitleMarginTop: var(--sp1-5x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.MobileSizeMin}) {
		--catSize: 50%;
		--catPadding: var(--sp2x);
		--catInnerPadding: var(--sp2x);
		--catInnerPaddingTop: var(--sp3x);
		--iconSize: var(--sp6x);
		--iconMarginBottom: var(--sp1-5x);
		--destSlideWidth: 40%;
		--destSlideTitleMarginTop: var(--sp1-5x);
	}
`;

export default CategoryNavbarStyle;
